module.exports = __webpack_public_path__ + "static/img/cds.b8aa334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/cds.png
// module id = YivI
// module chunks = 18